import { Cabin } from '../types/cabin';

export const CABINS: Cabin[] = [
  {
    id: 'saman',
    name: 'Luxury Saman',
    layout: 'featured',
    image: 'https://i.imgur.com/NnyaTSI.jpeg',
    badge: '⭐ La Joya del Refugio',
    shortDescription:
      'La más grande, luminosa y elegante. Vista panorámica, interiores premium y capacidad para 8 personas.',
    tags: ['8 Personas', 'Vista Montañas', 'Lujo Premium'],
    modalCaption: '✦ Hasta 8 personas · La Joya del Refugio',
    modalDescription:
      'La más grande, luminosa y elegante. Interiores premium con madera natural y vista panorámica inigualable a las montañas del Tolima.',
    amenities: ['8 Personas', 'Vista Montañas', 'Lujo Premium', 'WiFi', 'Parqueadero'],
  },
  {
    id: 'bilibil',
    name: 'Chalet Bilibil',
    layout: 'grid',
    image: 'https://i.imgur.com/TAjUUPx.png',
    cardCaption: '2 Personas · Piscina Privada',
    modalCaption: '✦ 2 personas · Piscina Privada',
    modalDescription:
      'El chalet de los momentos íntimos. Piscina privada bajo las estrellas y privacidad total rodeada de naturaleza.',
    amenities: ['2 Personas', 'Piscina Privada', 'Romántico', 'WiFi'],
  },
  {
    id: 'higueron',
    name: 'Higuerón',
    layout: 'grid',
    image: 'https://i.imgur.com/lezgBdS.jpeg',
    cardCaption: '2 Personas · Hamaca Balcón',
    modalCaption: '✦ 2 personas · Vistas Panorámicas',
    modalDescription: 'Balcón con hamaca y malla catamarán para contemplar las montañas durante horas.',
    amenities: ['2 Personas', 'Hamaca Balcón', 'Vista Montañas', 'WiFi'],
  },
  {
    id: 'totumo',
    name: 'Totumo',
    layout: 'grid',
    image: 'https://i.imgur.com/4HZMO79.jpeg',
    cardCaption: '2 Personas · Iglú · Piscina',
    modalCaption: '✦ 2 personas · Glamping Iglú',
    modalDescription:
      'Iglú acogedor rodeado de naturaleza pura. Arquitectura orgánica con confort moderno y piscina incluida.',
    amenities: ['2 Personas', 'Glamping Iglú', 'Piscina', 'WiFi'],
  },
  {
    id: 'carcoli',
    name: 'Domo Caracolí',
    layout: 'grid',
    image: 'https://i.imgur.com/pSGs0pU.jpeg',
    cardCaption: '2 Personas · Domo · Piscina',
    modalCaption: '✦ 2 personas · Domo Geodésico',
    modalDescription: 'Cúpula geodésica rodeada de vegetación exuberante con piscina privada.',
    amenities: ['2 Personas', 'Domo Geodésico', 'Piscina Privada', 'WiFi'],
  },
  {
    id: 'pomarosa',
    name: 'Chalet Poma Rosa',
    layout: 'secondary',
    image: 'https://i.imgur.com/RgttKvT.jpeg',
    shortDescription: 'Acogedor, íntimo y con vistas a las montañas del Tolima.',
    tags: ['2 Personas', 'Vista Montañas', 'Hamaca Pareja'],
    modalCaption: '✦ 2 personas · Vista Montañas',
    modalDescription: 'Acogedor, íntimo y con vistas directas a las montañas del Tolima. Hamaca para dos.',
    amenities: ['2 Personas', 'Vista Montañas', 'Hamaca Para Dos', 'WiFi'],
  },
  {
    id: 'ocobo',
    name: 'Ocobo',
    layout: 'mini',
    image: 'https://i.imgur.com/P8KmIRs.jpeg',
    cardSubtitle: 'Chalet Mini · 2 Personas',
    modalCaption: '✦ 2 personas · Chalet Mini',
    modalDescription: 'Pequeño y lleno de carácter. Acogedor con todos los retoques para una escapada romántica.',
    amenities: ['2 Personas', 'Chalet Mini', 'Naturaleza', 'WiFi'],
  },
  {
    id: 'cambulo',
    name: 'Cámbulo',
    layout: 'mini',
    image: 'https://i.imgur.com/A9oTfAN.jpeg',
    cardSubtitle: 'Chalet Mini · 2 Personas',
    modalCaption: '✦ 2 personas · Chalet Mini',
    modalDescription: 'Diseñado con detalles cálidos y acogedores. Ideal para esa escapada que llevan planeando.',
    amenities: ['2 Personas', 'Chalet Mini', 'Naturaleza', 'WiFi'],
  },
  {
    id: 'yarumo',
    name: 'Yarumo',
    layout: 'mini',
    image: 'https://i.imgur.com/1CZYcf4.png',
    cardSubtitle: 'Chalet Mini · 2 Personas',
    modalCaption: '✦ 2 personas · Chalet Mini',
    modalDescription: 'Personalidad acogedora y cálida para parejas que buscan simplicidad con encanto.',
    amenities: ['2 Personas', 'Chalet Mini', 'Naturaleza', 'WiFi'],
  },
];
